// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.SuspendUserModal_dashboard__y7Ady {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.SuspendUserModal_dashboardContain__cSFPr {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_dashboardContain__cSFPr,
.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_dashboard__y7Ady,
.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_cont2__Jf1KM {
  background-Color: #0f1824;
}

.SuspendUserModal_top_header__jfgEm .SuspendUserModal_top_header_inner__SN2W5 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.SuspendUserModal_cont2__Jf1KM {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.SuspendUserModal_footer__XFryr {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.SuspendUserModal_bodythemelight__oN4bo {
  background-color: #fff;
  padding-top: 90px;
}

.SuspendUserModal_bodythemedark__EuzYq {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.SuspendUserModal_headerthemelight__Cgr2r {
  background-color: #fff;
}

.SuspendUserModal_headerthemedark__8S8-G {
  background-color: #132337;
}

.SuspendUserModal_top_header__jfgEm {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.SuspendUserModal_menuthemelight__5oOX\\+ {
  background-color: #fff;
}

.SuspendUserModal_menuthemedark__qhWaz {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.SuspendUserModal_menulinklight__sn4hQ span {
  color: #666666 !important;
}

.SuspendUserModal_menulinklight__sn4hQ a {
  color: #CBCBCB !important;
}

.SuspendUserModal_menulinklight__sn4hQ:hover span, .SuspendUserModal_menulinklight__sn4hQ:hover a {
  color: #fff !important;
}

.SuspendUserModal_menulinkdarkSelected__yoe\\+s {
  background-color: #1c2e45;
  color: #3b82f6;
}

.SuspendUserModal_menuthemelight__5oOX\\+ .SuspendUserModal_menulinklightSelected__TNv6X {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.SuspendUserModal_menulinkdark__CW9E\\+ {
  color: #92afd3 !important;
}

.SuspendUserModal_menulinklight__sn4hQ:hover {
  color: #fff !important;
  background-color: #131F43;
}

.SuspendUserModal_menulinklight__sn4hQ .SuspendUserModal_sub_arrow__ROkOx svg path {
  stroke: #CBCBCB !important;
}

.SuspendUserModal_menulinklight__sn4hQ:hover .SuspendUserModal_sub_arrow__ROkOx svg path {
  stroke: #fff !important;
}

.SuspendUserModal_menulinkdark__CW9E\\+ .SuspendUserModal_sub_arrow__ROkOx svg path {
  stroke: #92afd3 !important;
}

.SuspendUserModal_menulinkdark__CW9E\\+:hover .SuspendUserModal_sub_arrow__ROkOx svg path {
  stroke: #fff !important;
}

.SuspendUserModal_menulinkdark__CW9E\\+:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.SuspendUserModal_headinglight__0FTn2 {
  color: #60677e;
}

.SuspendUserModal_headingdark__lHnyv {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.SuspendUserModal_searchboxlight__Gzc7l {
  background-color: #fff;
  border: none;
}

.SuspendUserModal_searchboxdark__kVSr7 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.SuspendUserModal_searchboxdark__kVSr7::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.SuspendUserModal_tableheadlight__kCrT1 {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.SuspendUserModal_tableheadlight__kCrT1 th {
  color: #fff;
}

thead .SuspendUserModal_tableheadlight__kCrT1 th:first-child,
thead .SuspendUserModal_tableheaddark__vliWy th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .SuspendUserModal_tableheadlight__kCrT1 th:last-child,
thead .SuspendUserModal_tableheaddark__vliWy th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.SuspendUserModal_table__xeT5w.SuspendUserModal_table-borderless__qSOxN {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.SuspendUserModal_tableheaddark__vliWy {
  background-color: #132337;
  color: #fff;
}

.SuspendUserModal_table-borderless__qSOxN tr:nth-child(even) {
  background-color: #F9FAFB;
}

.SuspendUserModal_table-borderless__qSOxN .SuspendUserModal_left-section__rSP\\+q {
  padding-top: 10px;
}

.SuspendUserModal_tablebodylight__8m2\\+C td,
.SuspendUserModal_tablebodydark__PXzqm td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.SuspendUserModal_tablebodylight__8m2\\+C {
  background-color: #fff;
}
.SuspendUserModal_tablebodylight__8m2\\+C:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.SuspendUserModal_tablebodydark__PXzqm {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.SuspendUserModal_tablebodydark__PXzqm:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.SuspendUserModal_paginationlight__ngfHo {
  color: #60677e !important;
  font-size: 13px !important;
}

.SuspendUserModal_paginationdark__A23VC {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.SuspendUserModal_formthemelight__6Bo\\+g {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.SuspendUserModal_formthemedark__LKORs {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.SuspendUserModal_formthemedark__LKORs ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.SuspendUserModal_viewformlight__2B04x {
  background-color: #f3f6f9;
}

.SuspendUserModal_permissionboxlight__88wZX {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.SuspendUserModal_permissionboxdark__3spXX {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.SuspendUserModal_errormsgclr__BhnWG {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.SuspendUserModal_graphclrlight__YmoB7 {
  background-color: #fff;
}

.SuspendUserModal_graphclrdark__CC8RQ {
  background-color: #132337;
}

/* 
Counter theme
*/
#SuspendUserModal_card1bglight__Vx0IO {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#SuspendUserModal_card1bgdark__H3EyO {
  background: #392f28;
}

#SuspendUserModal_card2bglight__mwSbn {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#SuspendUserModal_card2bgdark__Z0XOQ {
  background: #1c3238;
}

#SuspendUserModal_card3bglight__wRU0M {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#SuspendUserModal_card3bgdark__kelUR {
  background: #3a2434;
}

#SuspendUserModal_card4bglight__CGqTZ {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#SuspendUserModal_card4bgdark__2cXDi {
  background: #2f264f;
}

#SuspendUserModal_card1bgdark__H3EyO a, #SuspendUserModal_card1bgdark__H3EyO p,
#SuspendUserModal_card2bgdark__Z0XOQ a, #SuspendUserModal_card2bgdark__Z0XOQ p,
#SuspendUserModal_card3bgdark__kelUR a, #SuspendUserModal_card3bgdark__kelUR p,
#SuspendUserModal_card4bgdark__2cXDi a, #SuspendUserModal_card4bgdark__2cXDi p {
  color: #fff;
}

/* 
Action button theme
*/
.SuspendUserModal_actionbtnlight__6a1co {
  color: rgba(70, 71, 91, 0.8705882353);
}

.SuspendUserModal_actionbtnlight__6a1co:hover {
  cursor: pointer;
}

.SuspendUserModal_actionbtndark__dVqcz {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.SuspendUserModal_profiledropdownlight__hIhdJ {
  background-color: #fff;
}

.SuspendUserModal_profiledropdowndark__Ipdix {
  background-color: #151521;
}

.SuspendUserModal_settingsection__PUoHi #SuspendUserModal_addform__2WJdT.SuspendUserModal_formthemedark__LKORs .SuspendUserModal_savebtn__5RTKP {
  background-color: #3b82f6;
  color: #fff;
}

#SuspendUserModal_addform__2WJdT.SuspendUserModal_formthemedark__LKORs .SuspendUserModal_savebtn__5RTKP {
  background-color: #3b82f6;
  color: #fff;
}

.SuspendUserModal_profile_conatiner__CVdZo {
  border-radius: 5px !important;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_ag-theme-alpine__Hao9r .SuspendUserModal_ag-row__GCEWd {
  background: #000 !important;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_formbtn__iRYlV {
  background-color: #3b82f6;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_formbtn__iRYlV:hover {
  background-color: #2563eb;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_resetbtn__F8Yv7 {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_resetbtn__F8Yv7:hover {
  background-color: #3b82f6;
}

.SuspendUserModal_headingdark__lHnyv span {
  background-color: #132337;
}

.SuspendUserModal_resetbtn__F8Yv7 {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.SuspendUserModal_resetbtn__F8Yv7:hover,
.SuspendUserModal_resetbtn__F8Yv7:active,
.SuspendUserModal_resetbtn__F8Yv7:focus {
  background-color: #131F43;
  color: #fff;
}

.SuspendUserModal_addBtn__xSNkL {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.SuspendUserModal_addbtnlight__UnDrs {
  background-color: #38A169;
}

.SuspendUserModal_addbtndark__BXHiV {
  background-color: #3b82f6;
}

.SuspendUserModal_addbtndark__BXHiV:hover {
  background-color: #2563eb;
}

.SuspendUserModal_formthemedark__LKORs label {
  color: #92afd3;
}

.SuspendUserModal_addBtn__xSNkL svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.SuspendUserModal_addBtn__xSNkL:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.SuspendUserModal_cust_addBtn__eq3UU.SuspendUserModal_addBtn__xSNkL svg {
  top: 2px;
}

.SuspendUserModal_deleteBtn__HjXAe {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.SuspendUserModal_deleteBtn__HjXAe {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.SuspendUserModal_deleteBtn__HjXAe:active, .SuspendUserModal_deleteBtn__HjXAe:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.SuspendUserModal_deleteBtn__HjXAe svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.SuspendUserModal_deleteBtn__HjXAe:hover,
.SuspendUserModal_deleteBtn__HjXAe:active,
.SuspendUserModal_deleteBtn__HjXAe:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.SuspendUserModal_confirmBtn__5jylL {
  background-color: #131F43;
}

.SuspendUserModal_confirmBtn__5jylL:hover,
.SuspendUserModal_confirmBtn__5jylL:active,
.SuspendUserModal_confirmBtn__5jylL:focus {
  background-color: #131F43;
}

.SuspendUserModal_confirmBtn__5jylL svg {
  top: 0;
}

.SuspendUserModal_delPopContainer__UFiI9 .SuspendUserModal_modal-body__CXWeR {
  padding: 25px;
  text-align: center;
}

.SuspendUserModal_delPopContainer__UFiI9 .SuspendUserModal_delet_icon__UupwB {
  margin-bottom: 11px;
}

.SuspendUserModal_delPopContainer__UFiI9 p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.SuspendUserModal_arrowback__WeM1S svg {
  fill: #000;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_arrowback__WeM1S {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_arrowback__WeM1S svg {
  fill: #3b82f6;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_drpdwn_btn__6T-5R {
  background-color: #132337;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_empname__pBK1m {
  color: #92afd3 !important;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_navitemli__KYQme a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_tabnavli__V7KTw a.SuspendUserModal_settingsgeneral__SwNlr,
.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_tabnavli__V7KTw a.SuspendUserModal_settingslinks__-L34h:hover {
  background-color: #3b82f6;
  color: #fff;
}

.SuspendUserModal_bodythemedark__EuzYq .SuspendUserModal_tabnavli__V7KTw a.SuspendUserModal_settingslinks__-L34h {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.SuspendUserModal_headerthemedark__8S8-G .SuspendUserModal_dropdown_menu_contain__47sbM {
  background-color: #1c2e45;
  color: #fff;
}

.SuspendUserModal_headerthemedark__8S8-G .SuspendUserModal_dropdown_menu_contain__47sbM ul li a,
.SuspendUserModal_headerthemedark__8S8-G .SuspendUserModal_dropdown_menu_contain__47sbM .SuspendUserModal_dropdown_item__z\\+bDX,
.SuspendUserModal_headerthemedark__8S8-G .SuspendUserModal_dropdown_menu_contain__47sbM .SuspendUserModal_dropdown_item__z\\+bDX h5 {
  color: #fff;
}

.SuspendUserModal_headerthemedark__8S8-G .SuspendUserModal_dropdown_menu_contain__47sbM ul li a:hover,
.SuspendUserModal_headerthemedark__8S8-G .SuspendUserModal_dropdown_menu_contain__47sbM .SuspendUserModal_dropdown_item__z\\+bDX:hover {
  background-color: #132337;
  color: #fff;
}

.SuspendUserModal_dropdown_item__z\\+bDX:active {
  background-color: #F5F6FA;
}

.SuspendUserModal_profile_arrrow_dwn__\\+FJK2 {
  stroke: #132337;
}

.SuspendUserModal_headerthemedark__8S8-G .SuspendUserModal_profile_arrrow_dwn__\\+FJK2 {
  stroke: #fff;
}

.SuspendUserModal_dateinputbox1__hpJrk input,
.SuspendUserModal_dateinputbox1__hpJrk span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .SuspendUserModal_tableheadlight__kCrT1 th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .SuspendUserModal_dashboard__y7Ady {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .SuspendUserModal_cont2__Jf1KM {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .SuspendUserModal_sectionright__pxn9d {
    float: unset !important;
  }
  .SuspendUserModal_dashboard__y7Ady {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .SuspendUserModal_cont2__Jf1KM {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .SuspendUserModal_bodythemelight__oN4bo, .SuspendUserModal_bodythemedark__EuzYq {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .SuspendUserModal_exer_modal_contain__VmuAL .SuspendUserModal_modal-dialog__ehteN {
    max-width: 1055px;
  }
  .SuspendUserModal_delPopContainer__UFiI9 .SuspendUserModal_modal-dialog__ehteN {
    max-width: 350px;
  }
}
.SuspendUserModal_modalContainer__8aXt7 {
  max-width: 500px;
  width: 90%;
}

.SuspendUserModal_fieldContainer__rSMbH {
  margin-bottom: 20px;
  text-align: left;
}

.SuspendUserModal_fieldLabel__my6V4 {
  font-size: 14px;
  font-weight: 600;
  color: #131F43;
  margin-bottom: 4px;
  text-align: left;
}

.SuspendUserModal_selectInput__sGRHT {
  width: 100%;
  font-size: 14px;
}

.SuspendUserModal_textAreaInput__hgFjy {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s ease;
  resize: vertical;
  min-height: 80px;
}
.SuspendUserModal_textAreaInput__hgFjy:focus {
  border-color: #131F43;
  box-shadow: 0 0 0 2px rgba(19, 31, 67, 0.2);
}
.SuspendUserModal_textAreaInput__hgFjy::placeholder {
  color: #999;
}

.SuspendUserModal_resetbtn__F8Yv7 {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
  min-height: 50px;
  margin-right: 24px;
}

.SuspendUserModal_resetbtn__F8Yv7 svg {
  margin-right: 10px;
  position: relative;
  top: -1px;
}

.SuspendUserModal_resetbtn__F8Yv7:hover svg,
.SuspendUserModal_resetbtn__F8Yv7:active svg,
.SuspendUserModal_resetbtn__F8Yv7:focus svg {
  fill: #fff;
}

.SuspendUserModal_confirmIcon__ltNT5 {
  width: 54px;
  height: 54px;
  margin: 0 auto 20px auto;
  display: block;
}

.SuspendUserModal_passwordField__G4ssU {
  margin-bottom: 20px;
  text-align: left;
}

.SuspendUserModal_passwordLabel__mxZge {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #131F43;
  margin-bottom: 8px;
  text-align: left;
}

.SuspendUserModal_inputContainer__sr186 {
  position: relative;
  display: flex;
  align-items: center;
}

.SuspendUserModal_passwordInput__Q04CV {
  width: 100%;
  padding: 12px 45px 12px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s ease;
}
.SuspendUserModal_passwordInput__Q04CV:focus {
  border-color: #131F43;
  box-shadow: 0 0 0 2px rgba(19, 31, 67, 0.2);
}
.SuspendUserModal_passwordInput__Q04CV::placeholder {
  color: #999;
}

.SuspendUserModal_eyeButton__xKWl\\+ {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: background-color 0.2s ease;
}
.SuspendUserModal_eyeButton__xKWl\\+:hover {
  background-color: #f5f5f5;
}
.SuspendUserModal_eyeButton__xKWl\\+:focus {
  outline: 2px solid #131F43;
  outline-offset: 2px;
}
.SuspendUserModal_eyeButton__xKWl\\+ img {
  width: 18px;
  height: 18px;
  opacity: 0.7;
}

.SuspendUserModal_errorMessage__LzEr1 {
  color: red !important;
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 0;
  text-align: left;
  display: block;
  font-weight: 500;
}

.SuspendUserModal_text-red__P4DBT {
  color: #dc3545 !important;
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 0;
  text-align: left;
}

.SuspendUserModal_btn_container__WFH1E {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 30px;
}

.SuspendUserModal_resetPasswordBtn__dFU60 {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: #131F43;
  border: solid 1px #131F43;
  color: #fff;
  min-width: 150px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.SuspendUserModal_resetPasswordBtn__dFU60:hover,
.SuspendUserModal_resetPasswordBtn__dFU60:active,
.SuspendUserModal_resetPasswordBtn__dFU60:focus {
  background-color: #080d1b;
  border-color: #080d1b;
  color: #fff;
}

.SuspendUserModal_resetPasswordBtn__dFU60 svg {
  margin-right: 10px;
  position: relative;
  top: -1px;
  flex-shrink: 0;
}

@media only screen and (max-width: 360px) {
  .SuspendUserModal_btn_container__WFH1E {
    gap: 15px;
  }
  .SuspendUserModal_resetbtn__F8Yv7 {
    min-width: 100px;
  }
  .SuspendUserModal_resetPasswordBtn__dFU60 {
    min-width: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/NewModals/SuspendUserModal/SuspendUserModal.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ACxEF;;AD0EA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ACvEF;;ADyEA;;;EAGE,yBAlEoB;ACJtB;;ADwEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACrEF;;ADwEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACnEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBA5FY;ACmBd;;AD4EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAlHgB;EAmHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBA/GY;ACuCd;;AD2EA;EACE,yBA9HgB;ACsDlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAnIY;AC4Dd;;ADyEA;EACE,yBAjJgB;AC2ElB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ACuGpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ACuIhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBArNc;ACgJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBArMsB;EAsMtB,WA7LY;ACwHd;;ADwEA;;CAAA;AAGA;EACE,cAjMe;AC4HjB;;ADwEA;EACE,cArMe;ACgIjB;;ADwEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ACrEF;;ADwEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ACrEF;;ADuEA;EACE,cAtNe;ACkJjB;;ADuEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ACpEF;;ADsEA;EACE,WApOY;ACiKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAlPkB;EAmPlB,WA3PY;AC6Ld;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBAzQY;AC+Md;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cA/Qe;ACqNjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAjTa;ACwPjB;;AD8DA;;CAAA;AAGA;EACE,yBAhUgB;ACqQlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBA/UoB;EAgVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAnVY;ACyRd;;AD6DA;EACE,yBA/UkB;ACqRpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ACqSd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAzWY;AC8Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAlXY;ACuTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA3XY;ACgUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WAtYY;AC2Ud;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cAhZe;ACuVjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBApbkB;EAqblB,WApaY;AC0Wd;;AD4DA;EACE,yBAxbkB;EAyblB,WAxaY;AC+Wd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBArckB;AC4YpB;;AD4DA;EACE,yBAxcwB;AC+Y1B;;AD4DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAndkB;AC0ZpB;;AD6DA;EACE,yBAldgB;ACwZlB;;AD6DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AC8Zd;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AC2dhB;;AD4DA;EACE,yBAhgBY;ACucd;;AD2DA;EACE,yBAzfkB;ACicpB;;AD0DA;EACE,yBA3fwB;ACoc1B;;AD0DA;EACE,cAjgBiB;AC0cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ACxDF;;AD2DA;EACE,yBAzlBc;ACiiBhB;;AD2DA;;;EAGE,yBA/lBc;ACuiBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;ACyiBpB;;AD6DA;EACE,aAvmBkB;AC6iBpB;;AD6DA;EACE,yBAnmBgB;ACyiBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ACwiBd;;AD6DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AC8iBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ACojBd;;AD4DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;ACyjBd;;AD4DA;;;EAGE,WAxnBY;AC+jBd;;AD4DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ACqkBd;;AD4DA;EACE,yBAhrBO;ACunBT;;AD4DA;EACE,eAjpBgB;ACwlBlB;;AD4DA;EACE,YA1oBY;ACilBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AApsBA;EACI,gBAAA;EACA,UAAA;AAssBJ;;AAnsBA;EACI,mBAAA;EACA,gBAAA;AAssBJ;;AAnsBA;EACI,eAAA;EACA,gBAAA;EACA,cDEY;ECDZ,kBAAA;EACA,gBAAA;AAssBJ;;AAnsBA;EACI,WAAA;EACA,eAAA;AAssBJ;;AAnsBA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;AAssBJ;AApsBI;EACI,qBDpBQ;ECqBR,2CAAA;AAssBR;AAnsBI;EACI,WAAA;AAqsBR;;AAjsBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cDnCY;ECoCZ,gBAAA;EACA,gBAAA;EACA,kBAAA;AAosBJ;;AAjsBA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AAosBJ;;AAjsBA;;;EAGI,UDLU;ACysBd;;AAjsBA;EACI,WAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;AAosBJ;;AAjsBA;EACI,mBAAA;EACA,gBAAA;AAosBJ;;AAjsBA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cDrEY;ECsEZ,kBAAA;EACA,gBAAA;AAosBJ;;AAjsBA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAosBJ;;AAjsBA;EACI,WAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;AAosBJ;AAlsBI;EACI,qBD1FQ;EC2FR,2CAAA;AAosBR;AAjsBI;EACI,WAAA;AAmsBR;;AA/rBA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;AAksBJ;AAhsBI;EACI,yBAAA;AAksBR;AA/rBI;EACI,0BAAA;EACA,mBAAA;AAisBR;AA9rBI;EACI,WAAA;EACA,YAAA;EACA,YAAA;AAgsBR;;AA5rBA;EACI,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA+rBJ;;AA5rBA;EACI,yBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA+rBJ;;AA5rBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AA+rBJ;;AA5rBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBDhKY;ECiKZ,yBAAA;EACA,WDrHU;ECsHV,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA+rBJ;;AA5rBA;;;EAGI,yBAAA;EACA,qBAAA;EACA,WDnIU;ACk0Bd;;AA5rBA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AA+rBJ;;AA5rBA;EACI;IACI,SAAA;EA+rBN;EA5rBE;IACI,gBAAA;EA8rBN;EA3rBE;IACI,gBAAA;EA6rBN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../../styles/Variables/Variables.scss\";\n\n.modalContainer {\n    max-width: 500px;\n    width: 90%;\n}\n\n.fieldContainer {\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n.fieldLabel {\n    font-size: 14px;\n    font-weight: 600;\n    color: $primary-color;\n    margin-bottom: 4px;\n    text-align: left;\n}\n\n.selectInput {\n    width: 100%;\n    font-size: 14px;\n}\n\n.textAreaInput {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.3s ease;\n    resize: vertical;\n    min-height: 80px;\n\n    &:focus {\n        border-color: $primary-color;\n        box-shadow: 0 0 0 2px rgba($primary-color, 0.2);\n    }\n\n    &::placeholder {\n        color: #999;\n    }\n}\n\n.resetbtn {\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px;\n    background-color: transparent;\n    border: solid 1px $primary-color;\n    color: $primary-color;\n    min-width: 113px;\n    min-height: 50px;\n    margin-right: 24px;\n}\n\n.resetbtn svg {\n    margin-right: 10px;\n    position: relative;\n    top: -1px;\n}\n\n.resetbtn:hover svg,\n.resetbtn:active svg,\n.resetbtn:focus svg {\n    fill: $white-color;\n}\n\n.confirmIcon {\n    width: 54px;\n    height: 54px;\n    margin: 0 auto 20px auto;\n    display: block;\n}\n\n.passwordField {\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n.passwordLabel {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: $primary-color;\n    margin-bottom: 8px;\n    text-align: left;\n}\n\n.inputContainer {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.passwordInput {\n    width: 100%;\n    padding: 12px 45px 12px 12px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.3s ease;\n\n    &:focus {\n        border-color: $primary-color;\n        box-shadow: 0 0 0 2px rgba($primary-color, 0.2);\n    }\n\n    &::placeholder {\n        color: #999;\n    }\n}\n\n.eyeButton {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 3px;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n        background-color: #f5f5f5;\n    }\n\n    &:focus {\n        outline: 2px solid $primary-color;\n        outline-offset: 2px;\n    }\n\n    img {\n        width: 18px;\n        height: 18px;\n        opacity: 0.7;\n    }\n}\n\n.errorMessage {\n    color: red !important;\n    font-size: 14px;\n    margin-top: 4px;\n    margin-bottom: 0;\n    text-align: left;\n    display: block;\n    font-weight: 500;\n}\n\n.text-red {\n    color: #dc3545 !important;\n    font-size: 12px;\n    margin-top: 4px;\n    margin-bottom: 0;\n    text-align: left;\n}\n\n.btn_container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 24px;\n    margin-top: 30px;\n}\n\n.resetPasswordBtn {\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 5px;\n    background-color: $primary-color;\n    border: solid 1px $primary-color;\n    color: $white-color;\n    min-width: 150px;\n    min-height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.resetPasswordBtn:hover,\n.resetPasswordBtn:active,\n.resetPasswordBtn:focus {\n    background-color: darken($primary-color, 10%);\n    border-color: darken($primary-color, 10%);\n    color: $white-color;\n}\n\n.resetPasswordBtn svg {\n    margin-right: 10px;\n    position: relative;\n    top: -1px;\n    flex-shrink: 0;\n}\n\n@media only screen and (max-width: 360px) {\n    .btn_container {\n        gap: 15px;\n    }\n    \n    .resetbtn {\n        min-width: 100px;\n    }\n    \n    .resetPasswordBtn {\n        min-width: 120px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `SuspendUserModal_dashboard__y7Ady`,
	"dashboardContain": `SuspendUserModal_dashboardContain__cSFPr`,
	"bodythemedark": `SuspendUserModal_bodythemedark__EuzYq`,
	"cont2": `SuspendUserModal_cont2__Jf1KM`,
	"top_header": `SuspendUserModal_top_header__jfgEm`,
	"top_header_inner": `SuspendUserModal_top_header_inner__SN2W5`,
	"footer": `SuspendUserModal_footer__XFryr`,
	"bodythemelight": `SuspendUserModal_bodythemelight__oN4bo`,
	"headerthemelight": `SuspendUserModal_headerthemelight__Cgr2r`,
	"headerthemedark": `SuspendUserModal_headerthemedark__8S8-G`,
	"menuthemelight": `SuspendUserModal_menuthemelight__5oOX+`,
	"menuthemedark": `SuspendUserModal_menuthemedark__qhWaz`,
	"menulinklight": `SuspendUserModal_menulinklight__sn4hQ`,
	"menulinkdarkSelected": `SuspendUserModal_menulinkdarkSelected__yoe+s`,
	"menulinklightSelected": `SuspendUserModal_menulinklightSelected__TNv6X`,
	"menulinkdark": `SuspendUserModal_menulinkdark__CW9E+`,
	"sub_arrow": `SuspendUserModal_sub_arrow__ROkOx`,
	"headinglight": `SuspendUserModal_headinglight__0FTn2`,
	"headingdark": `SuspendUserModal_headingdark__lHnyv`,
	"searchboxlight": `SuspendUserModal_searchboxlight__Gzc7l`,
	"searchboxdark": `SuspendUserModal_searchboxdark__kVSr7`,
	"tableheadlight": `SuspendUserModal_tableheadlight__kCrT1`,
	"tableheaddark": `SuspendUserModal_tableheaddark__vliWy`,
	"table": `SuspendUserModal_table__xeT5w`,
	"table-borderless": `SuspendUserModal_table-borderless__qSOxN`,
	"left-section": `SuspendUserModal_left-section__rSP+q`,
	"tablebodylight": `SuspendUserModal_tablebodylight__8m2+C`,
	"tablebodydark": `SuspendUserModal_tablebodydark__PXzqm`,
	"paginationlight": `SuspendUserModal_paginationlight__ngfHo`,
	"paginationdark": `SuspendUserModal_paginationdark__A23VC`,
	"formthemelight": `SuspendUserModal_formthemelight__6Bo+g`,
	"formthemedark": `SuspendUserModal_formthemedark__LKORs`,
	"viewformlight": `SuspendUserModal_viewformlight__2B04x`,
	"permissionboxlight": `SuspendUserModal_permissionboxlight__88wZX`,
	"permissionboxdark": `SuspendUserModal_permissionboxdark__3spXX`,
	"errormsgclr": `SuspendUserModal_errormsgclr__BhnWG`,
	"graphclrlight": `SuspendUserModal_graphclrlight__YmoB7`,
	"graphclrdark": `SuspendUserModal_graphclrdark__CC8RQ`,
	"card1bglight": `SuspendUserModal_card1bglight__Vx0IO`,
	"card1bgdark": `SuspendUserModal_card1bgdark__H3EyO`,
	"card2bglight": `SuspendUserModal_card2bglight__mwSbn`,
	"card2bgdark": `SuspendUserModal_card2bgdark__Z0XOQ`,
	"card3bglight": `SuspendUserModal_card3bglight__wRU0M`,
	"card3bgdark": `SuspendUserModal_card3bgdark__kelUR`,
	"card4bglight": `SuspendUserModal_card4bglight__CGqTZ`,
	"card4bgdark": `SuspendUserModal_card4bgdark__2cXDi`,
	"actionbtnlight": `SuspendUserModal_actionbtnlight__6a1co`,
	"actionbtndark": `SuspendUserModal_actionbtndark__dVqcz`,
	"profiledropdownlight": `SuspendUserModal_profiledropdownlight__hIhdJ`,
	"profiledropdowndark": `SuspendUserModal_profiledropdowndark__Ipdix`,
	"settingsection": `SuspendUserModal_settingsection__PUoHi`,
	"addform": `SuspendUserModal_addform__2WJdT`,
	"savebtn": `SuspendUserModal_savebtn__5RTKP`,
	"profile_conatiner": `SuspendUserModal_profile_conatiner__CVdZo`,
	"ag-theme-alpine": `SuspendUserModal_ag-theme-alpine__Hao9r`,
	"ag-row": `SuspendUserModal_ag-row__GCEWd`,
	"formbtn": `SuspendUserModal_formbtn__iRYlV`,
	"resetbtn": `SuspendUserModal_resetbtn__F8Yv7`,
	"addBtn": `SuspendUserModal_addBtn__xSNkL`,
	"addbtnlight": `SuspendUserModal_addbtnlight__UnDrs`,
	"addbtndark": `SuspendUserModal_addbtndark__BXHiV`,
	"cust_addBtn": `SuspendUserModal_cust_addBtn__eq3UU`,
	"deleteBtn": `SuspendUserModal_deleteBtn__HjXAe`,
	"confirmBtn": `SuspendUserModal_confirmBtn__5jylL`,
	"delPopContainer": `SuspendUserModal_delPopContainer__UFiI9`,
	"modal-body": `SuspendUserModal_modal-body__CXWeR`,
	"delet_icon": `SuspendUserModal_delet_icon__UupwB`,
	"arrowback": `SuspendUserModal_arrowback__WeM1S`,
	"drpdwn_btn": `SuspendUserModal_drpdwn_btn__6T-5R`,
	"empname": `SuspendUserModal_empname__pBK1m`,
	"navitemli": `SuspendUserModal_navitemli__KYQme`,
	"tabnavli": `SuspendUserModal_tabnavli__V7KTw`,
	"settingsgeneral": `SuspendUserModal_settingsgeneral__SwNlr`,
	"settingslinks": `SuspendUserModal_settingslinks__-L34h`,
	"dropdown_menu_contain": `SuspendUserModal_dropdown_menu_contain__47sbM`,
	"dropdown_item": `SuspendUserModal_dropdown_item__z+bDX`,
	"profile_arrrow_dwn": `SuspendUserModal_profile_arrrow_dwn__+FJK2`,
	"dateinputbox1": `SuspendUserModal_dateinputbox1__hpJrk`,
	"sectionright": `SuspendUserModal_sectionright__pxn9d`,
	"exer_modal_contain": `SuspendUserModal_exer_modal_contain__VmuAL`,
	"modal-dialog": `SuspendUserModal_modal-dialog__ehteN`,
	"modalContainer": `SuspendUserModal_modalContainer__8aXt7`,
	"fieldContainer": `SuspendUserModal_fieldContainer__rSMbH`,
	"fieldLabel": `SuspendUserModal_fieldLabel__my6V4`,
	"selectInput": `SuspendUserModal_selectInput__sGRHT`,
	"textAreaInput": `SuspendUserModal_textAreaInput__hgFjy`,
	"confirmIcon": `SuspendUserModal_confirmIcon__ltNT5`,
	"passwordField": `SuspendUserModal_passwordField__G4ssU`,
	"passwordLabel": `SuspendUserModal_passwordLabel__mxZge`,
	"inputContainer": `SuspendUserModal_inputContainer__sr186`,
	"passwordInput": `SuspendUserModal_passwordInput__Q04CV`,
	"eyeButton": `SuspendUserModal_eyeButton__xKWl+`,
	"errorMessage": `SuspendUserModal_errorMessage__LzEr1`,
	"text-red": `SuspendUserModal_text-red__P4DBT`,
	"btn_container": `SuspendUserModal_btn_container__WFH1E`,
	"resetPasswordBtn": `SuspendUserModal_resetPasswordBtn__dFU60`
};
export default ___CSS_LOADER_EXPORT___;
